export enum QuestionType {
  binary = 1,
  option = 2,
  text = 3,
  number = 4,
  date = 5,
  nestedOption = 6
}
